import { render, staticRenderFns } from "./walletlist-edit.vue?vue&type=template&id=3856f188&"
import script from "./walletlist-edit.vue?vue&type=script&lang=js&"
export * from "./walletlist-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports